/* =============================================================
   Vivo-style EU/UK/US size unit toggle  (product.vivo template)
   Loads ONLY on templates/product.vivo (guarded in theme.liquid).

   DISPLAY-ONLY: it relabels the visible size numbers. The radio
   <input value="..."> keeps its real EU value, so add-to-cart,
   the cart drawer, inventory and checkout stay 100% native.
   ============================================================= */
(function () {
  'use strict';

  /* Standard men's EU -> UK / US shoe conversion.
     Edit these values to match your own size chart. */
  var SIZE_MAP = {
    '36': { uk: '3.5', us: '4.5' },
    '37': { uk: '4',   us: '5'   },
    '38': { uk: '5',   us: '6'   },
    '39': { uk: '6',   us: '7'   },
    '40': { uk: '6.5', us: '7.5' },
    '41': { uk: '7',   us: '8'   },
    '42': { uk: '8',   us: '9'   },
    '43': { uk: '9',   us: '10'  },
    '44': { uk: '9.5', us: '10.5'},
    '45': { uk: '10.5',us: '11.5'},
    '46': { uk: '11',  us: '12'  },
    '47': { uk: '12',  us: '13'  },
    '48': { uk: '13',  us: '14'  },
    '49': { uk: '14',  us: '15'  },
    '50': { uk: '14.5',us: '15.5'}
  };

  var UNIT_KEY = 'vivoSizeUnit';
  var UNITS = ['eu']; /* UK & US removed — EU only. Restore ['eu','uk','us'] to bring them back. */
  var observer = null;

  function getUnit() {
    var u = null;
    try { u = localStorage.getItem(UNIT_KEY); } catch (e) {}
    return UNITS.indexOf(u) === -1 ? 'eu' : u;
  }
  function setUnit(u) { try { localStorage.setItem(UNIT_KEY, u); } catch (e) {} }

  function convert(eu, unit) {
    eu = String(eu).trim();
    if (unit === 'eu') return eu;
    var m = SIZE_MAP[eu];
    if (!m) return eu;                 // unknown size -> leave as EU (safe)
    return unit === 'uk' ? m.uk : m.us;
  }

  /* Real EU value = the paired radio input's value (never changed). */
  function euOf(label) {
    var id = label.getAttribute('for');
    var input = id ? document.getElementById(id) : null;
    if (!input) input = label.previousElementSibling;
    return input ? (input.getAttribute('value') || input.value || '') : label.textContent.trim();
  }

  function relabel(fieldset, unit) {
    fieldset.querySelectorAll('label.product__item-option').forEach(function (label) {
      var span = label.querySelector('span') || label;
      if (!span.hasAttribute('data-eu')) span.setAttribute('data-eu', euOf(label));
      span.textContent = convert(span.getAttribute('data-eu'), unit);
    });
    var checked = fieldset.querySelector('input[type="radio"]:checked');
    var valDisplay = fieldset.querySelector('.option_value');
    if (checked && valDisplay) valDisplay.textContent = convert(checked.value, unit);
  }

  function buildToggle(fieldset) {
    if (UNITS.length < 2) return; /* nothing to switch between — hide the toggle entirely */
    if (fieldset.querySelector('.vivo-unit-toggle')) return;
    var wrap = document.createElement('div');
    wrap.className = 'vivo-unit-toggle';
    UNITS.forEach(function (u) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'vivo-unit-btn';
      b.setAttribute('data-unit', u);
      b.textContent = u.toUpperCase();
      wrap.appendChild(b);
    });
    var labelRow = fieldset.querySelector('.form__label');
    (labelRow || fieldset).appendChild(wrap);
    wrap.addEventListener('click', function (e) {
      var btn = e.target.closest('.vivo-unit-btn');
      if (!btn) return;
      e.preventDefault();
      var unit = btn.getAttribute('data-unit');
      setUnit(unit);
      applyAll(unit);
    });
  }

  function markActive(unit) {
    document.querySelectorAll('.vivo-unit-toggle .vivo-unit-btn').forEach(function (b) {
      b.classList.toggle('is-active', b.getAttribute('data-unit') === unit);
    });
  }

  function sizeFieldsets() {
    var list = [].slice.call(document.querySelectorAll('fieldset.product-form__input_size'));
    if (list.length) return list;
    /* Fallback: a variant fieldset whose label mentions "size". */
    return [].slice.call(document.querySelectorAll('fieldset.product-form__input')).filter(function (fs) {
      var lbl = fs.querySelector('.form__label');
      return lbl && /size/i.test(lbl.textContent) && fs.querySelector('label.product__item-option');
    });
  }

  function applyAll(unit) {
    unit = unit || getUnit();
    if (observer) observer.disconnect();          // don't react to our own writes
    sizeFieldsets().forEach(function (fs) {
      buildToggle(fs);
      relabel(fs, unit);
    });
    markActive(unit);
    reconnect();
  }

  var scheduled = false;
  function scheduleApply() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () { scheduled = false; applyAll(); });
  }

  function reconnect() {
    var root = document.querySelector('.product-detail__variant-picker');
    if (!root) return;
    try {
      if (!observer) observer = new MutationObserver(scheduleApply);
      observer.observe(root, { childList: true, subtree: true });
    } catch (e) {}
  }

  function init() { applyAll(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
